import { DEFAULT_PAGE_SIZE } from '../constants/pagination'
import { ApiResponse, MailRule } from '../types'
import { apiService } from './api.service'

class MailRuleService {
  async getMailRules(params?: { page?: number; page_size?: number; full_perms?: boolean }): Promise<ApiResponse<MailRule>> {
    const response = await apiService.get<ApiResponse<MailRule>>('mail_rules/', { params })
    return response.data
  }

  async getMailRule(id: number): Promise<MailRule> {
    const response = await apiService.get<MailRule>(`mail_rules/${id}/`)
    return response.data
  }

  async createMailRule(data: Partial<MailRule>): Promise<MailRule> {
    const response = await apiService.post<MailRule>('mail_rules/', data)
    return response.data
  }

  async updateMailRule(id: number, data: Partial<MailRule>): Promise<MailRule> {
    const response = await apiService.patch<MailRule>(`mail_rules/${id}/`, data)
    return response.data
  }

  async deleteMailRule(id: number): Promise<void> {
    await apiService.delete(`mail_rules/${id}/`)
  }

  // Methods for ManagementList compatibility
  async listAll(params?: any): Promise<ApiResponse<MailRule>> {
    return this.getMailRules(params)
  }

  async listFiltered(
    page: number,
    _ordering?: string,
    sortField?: string,
    sortReverse?: boolean,
    nameFilter?: string,
    _includeDocumentCount?: boolean,
    extraParams?: any
  ): Promise<ApiResponse<MailRule>> {
    const params: any = {
      page,
      page_size: extraParams?.page_size ?? DEFAULT_PAGE_SIZE,
      full_perms: true,
    }

    if (sortField) {
      const prefix = sortReverse ? '-' : ''
      params.ordering = `${prefix}${sortField}`
    }

    if (nameFilter) {
      params.name__icontains = nameFilter
    }

    if (extraParams) {
      Object.assign(params, extraParams)
    }

    return this.getMailRules(params)
  }

  async delete(rule: MailRule): Promise<void> {
    return this.deleteMailRule(rule.id)
  }

  // Alias methods for EditDialog compatibility
  async create(data: Partial<MailRule>): Promise<MailRule> {
    return this.createMailRule(data)
  }

  async update(id: number, data: Partial<MailRule>): Promise<MailRule> {
    return this.updateMailRule(id, data)
  }

  // Bulk edit for permissions
  async bulkEditObjects(objects: number[], operation: string, permissions?: any, merge?: boolean): Promise<void> {
    const params: any = {
      objects,
      object_type: 'mail_rules',
      operation,
    }

    if (operation === 'set_permissions' && permissions) {
      params.owner = permissions.owner
      params.permissions = permissions.set_permissions
      params.merge = merge
    }

    await apiService.post('bulk_edit_objects/', params)
  }
}

export const mailRuleService = new MailRuleService()
